// src/components/checkout/PickupTimeSelector.jsx
import React from "react";
import useCheckoutStore from "../../store/useCheckoutStore";

const PickupTimeSelector = ({
  shopHours,
  pickupTimeType,
  scheduledPickup,
  setPickupError,
  pickupError,
}) => {
  const { updateCheckoutData } = useCheckoutStore();


  const now = new Date();
  const todayDay = now.getDay();
  const hoursConfig = shopHours[todayDay];


  const generateSlots = () => {
    if (!hoursConfig || hoursConfig === "Closed") return [];

    const [openH, openM] = hoursConfig.open.split(":").map(Number);
    const [closeH, closeM] = hoursConfig.close.split(":").map(Number);

    const opening = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      openH,
      openM
    );
    let closing = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      closeH,
      closeM
    );

    if (closing <= opening) {
      closing.setDate(closing.getDate() + 1);
    }

    const buffer = new Date(now.getTime() + 5 * 60 * 1000);
    let slot = new Date(Math.max(opening.getTime(), buffer.getTime()));
    slot.setMinutes(Math.ceil(slot.getMinutes() / 15) * 15, 0, 0);

    const slots = [];
    while (slot <= closing) {
      slots.push({
        value: slot.toISOString(),
        label: slot.toLocaleTimeString("pl-PL", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
      slot = new Date(slot.getTime() + 15 * 60 * 1000);
    }

    return slots;
  };

  const slots = generateSlots();

  return (
    <div className="card">
      <h2>Czas odbioru</h2>
      <label>
        <input
          type="radio"
          name="pickupTime"
          value="asap"
          checked={pickupTimeType === "asap"}
          onChange={() =>
            updateCheckoutData({ pickupTimeType: "asap", scheduledPickup: "" })
          }
        />
        Jak najszybciej
      </label>
      <label>
        <input
          type="radio"
          name="pickupTime"
          value="scheduled"
          checked={pickupTimeType === "scheduled"}
          onChange={() => updateCheckoutData({ pickupTimeType: "scheduled" })}
        />
        Zaplanowany czas
      </label>
      {pickupTimeType === "scheduled" && (
        <div style={{ marginTop: "1rem" }}>
          {slots.length === 0 ? (
            <div className="error-text">Dzisiaj lokal jest zamknięty.</div>
          ) : (
            <select
              className="time-slot-select"
              value={scheduledPickup}
              onChange={(e) =>
                updateCheckoutData({ scheduledPickup: e.target.value })
              }
              required
            >
              <option value="">Wybierz godzinę</option>
              {slots.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
            </select>
          )}
          {pickupError && <div className="error-text">{pickupError}</div>}
        </div>
      )}
    </div>
  );
};

export default PickupTimeSelector;
